import Icon from '~/src/common/components/Icon';
import { ImageParams } from '~/src/common/typings/image';
import { getImageUrlFromFormat } from '~/src/common/utils/cloudinary';
import {
  GetRecipeByIdOrSlug200,
  GetRecipeByIdOrSlug200IngredientsItemArticle,
} from '~/src/queries/api-ecom/generated/api-ecom.schemas';

import * as S from './layout';

interface IngredientImageProps {
  image: Nullable<GetRecipeByIdOrSlug200IngredientsItemArticle['images'][number]>;
  alt: string;
}

export const IngredientImage = ({ image, alt }: IngredientImageProps) => {
  if (!image) {
    return (
      <S.IngredientGenericContainer>
        <Icon name="ingredient" size={20} />
      </S.IngredientGenericContainer>
    );
  }

  const imageUrl = getImageUrlFromFormat(image, 'card_ratio', ImageParams.recipeIngredient);

  return <S.IngredientCardImage src={imageUrl} alt={alt || ''} />;
};

interface Props {
  ingredient: GetRecipeByIdOrSlug200['ingredients'][number];
  displayQuantity?: boolean;
}

const IngredientItem = ({ ingredient, displayQuantity = false }: Props) => {
  const { name, article, quantity } = ingredient;

  return (
    <div>
      <IngredientImage image={article?.images[0]} alt={article?.slug ?? name} />
      <S.IngredientInformations>
        <p>{name}</p>
        {displayQuantity ? <p>{quantity}</p> : null}
      </S.IngredientInformations>
    </div>
  );
};

export default IngredientItem;
